'use client';

import { type QuotaFormValues } from '@/widgets/project-creation-stepper/model';
import { useForm } from 'react-hook-form';
import { Form } from 'shared/ui/form';
import { DiskSelect } from './disk-select';
import { Button } from '@/shared/ui/button';
import { useSlug } from '@/shared/hooks/useSlug';
import { useQueryWithOnError } from '@/shared/hooks/query/useQueryWithOnError';
import { getQuota } from '@/enteties/tariff/api';
import { useEffect, useMemo, useState } from 'react';
import * as m from '@paraglide/messages';
import parse from 'html-react-parser';
import { useChangeQuota } from '../hooks/useChangeQuota';
import { Loader2 } from 'lucide-react';
export const SettingsDiskForm = () => {
  const slug = useSlug();
  const [defaultValue, setDefaultValue] = useState<number>(10);
  const {
    data: quota,
    isSuccess
  } = useQueryWithOnError({
    ...getQuota.queryOptions(slug)
  });
  useEffect(() => {
    if (isSuccess && quota?.resourcesQuota?.VOLUME?.quota) setDefaultValue(quota?.resourcesQuota?.VOLUME?.quota);
  }, [isSuccess]);
  const quotaValues = useMemo(() => quota?.resourcesQuota, [quota]);
  const {
    mutate: changeQuota,
    isPending
  } = useChangeQuota();
  const form = useForm<QuotaFormValues>({
    values: {
      tariffId: quotaValues?.VOLUME?.tariffId || 1,
      resourceClass: quotaValues?.VOLUME?.resourceClass || '',
      resourceType: 'VOLUME',
      quota: quotaValues?.VOLUME?.quota || 0
    }
  });
  const onSubmit = (data: QuotaFormValues) => {
    changeQuota({
      slug,
      params: {
        resourceType: data.resourceType,
        quota: data.quota
      }
    }, {
      onSuccess: () => {
        form.reset(data);
        setDefaultValue(data.quota);
      }
    });
  };
  return <Form {...form} data-sentry-element="Form" data-sentry-component="SettingsDiskForm" data-sentry-source-file="settings-disk-form.tsx">
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <DiskSelect nameSelectType="resourceType" nameSelectClass="resourceClass" nameSlider="quota" defaultValue={defaultValue} onlyIncrease isSelectClassDisabled isSelectTypeDisabled data-sentry-element="DiskSelect" data-sentry-source-file="settings-disk-form.tsx" />
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4 items-center">
          <p className="text-sm text-muted-foreground">
            {parse(m.quota_allocated_info({
            allocated: quotaValues?.VOLUME?.allocated || 0,
            quota: defaultValue || quotaValues?.VOLUME?.quota || 0
          }))}
          </p>
          <Button size="sm" type="submit" className="w-full md:w-[101px]" disabled={!form.formState.isDirty || isPending} data-sentry-element="Button" data-sentry-source-file="settings-disk-form.tsx">
            {isPending ? <Loader2 className="size-4 animate-spin" /> : m.btn_apply()}
          </Button>
        </div>
      </form>
    </Form>;
};